import { Button, FormControl, VStack } from '@chakra-ui/react';
import { SignUpInput } from './components/SignUpInput';
import { _js } from '@ifixit/localize';
import { useState } from 'react';
import type { FormEvent, ChangeEvent } from 'react';
import { FormError } from '../FormError';
import { SSOLoginButtons } from '../SSOLoginButtons';
import { useEmailValidation } from './hooks/useEmailValidation';
import { Auth } from 'Shared/auth';
import { fireGlobal } from 'Shared/utils';
import { getErrorMessage } from '../LogIn/LogIn';
import { shopifySsoAndGoToLastPage } from './utils/shopifyUtils';

interface EmailProps {
   onNavigateToLogin: (email: string) => void;
   onNavigateToRegister: (email: string) => void;
}

export const Email = ({ onNavigateToLogin, onNavigateToRegister }: EmailProps) => {
   const [email, setEmail] = useState<string>((window as any).App?.inviteEmail ?? '');
   const [ssoError, setSsoError] = useState<string | null>(null);

   const { isSubmitting, error, clearError, submitEmail } = useEmailValidation({
      onNavigateToLogin,
      onNavigateToRegister,
   });

   const ssoLoginHandler = (response: any) => {
      (Auth as any).clearCookies();

      if (response.loggedIn) {
         fireGlobal('login.success', response);
         shopifySsoAndGoToLastPage();
      } else {
         setSsoError(getErrorMessage(response));
         fireGlobal('login.failure', response);
      }
   };

   const emailFieldProvided = !!(window as any).App?.inviteEmail;

   const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setEmail(value);
      if (error) {
         clearError();
      }
   };

   const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      void submitEmail(email);
   };

   return (
      <VStack
         className="email-wrapper"
         flexDirection="column"
         spacing={6}
         paddingY={8}
         paddingX={6}
         bgColor="white"
         borderWidth={1}
         borderRadius="base"
         fontSize="16px"
         width={{ base: '100%', md: '384px' }}
      >
         <form onSubmit={handleSubmit} className="email-form" style={{ width: '100%' }}>
            <VStack
               spacing={6}
               sx={{
                  '& > div': { width: '100%' },
               }}
            >
               <SSOLoginButtons
                  loginHandler={ssoLoginHandler}
                  error={ssoError}
                  setError={setSsoError}
                  register={true}
               />
               <FormControl isInvalid={Boolean(error)}>
                  <SignUpInput
                     field={{
                        name: 'email',
                        value: email,
                        onChange: handleEmailChange,
                        onBlur: () => {},
                        type: 'email',
                        isRequired: true,
                        autoComplete: 'section-register email',
                        placeholder: 'albert@domain.com',
                     }}
                     label={_js('Email')}
                     helperText={_js('Enter your email address to login or sign up.')}
                     id="reg-email"
                     isDisabled={emailFieldProvided}
                  />
                  <FormError>{error}</FormError>
               </FormControl>
               <Button
                  variant="cta"
                  width="full"
                  type="submit"
                  id="registerBtn"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
               >
                  {_js('Continue')}
               </Button>
            </VStack>
         </form>
      </VStack>
   );
};
